// Runtime branding — the primary colour is injectable so the console can be white-labelled
// without a rebuild (a later slice can hydrate this from a /public/branding endpoint).
export const BRAND = {
  name: (import.meta as { env?: Record<string, string> }).env?.VITE_BRAND_NAME ?? 'Payments Console',
}

export function applyPrimary(color?: string) {
  if (color) document.documentElement.style.setProperty('--primary', color)
}
